<template>
  <div class="apk-view">
    <!-- Page Header -->
    <div class="page-header">
      <div>
        <h1 class="page-title">Gestion APK</h1>
        <p class="page-subtitle">Gérer les versions de l'application mobile</p>
      </div>
      <v-btn v-if="isAdmin" color="secondary" class="add-btn" @click="dialog = true">
        <v-icon left>mdi-plus</v-icon>
        Nouvelle APK
      </v-btn>
    </div>

    <!-- Dialog -->
    <v-dialog v-model="dialog" max-width="550px">
      <v-card class="modern-card">
        <v-card-title class="dialog-title">
          <v-icon left color="primary">mdi-android</v-icon>
          {{ form_title }}
        </v-card-title>
        <v-card-text class="dialog-content">
          <v-row>
            <v-col cols="12">
              <v-file-input
                outlined
                dense
                v-model="mobile.file"
                label="Fichier APK"
                prepend-inner-icon="mdi-file-document"
                prepend-icon=""
                accept=".apk"
              ></v-file-input>
            </v-col>
            <v-col cols="12" sm="6">
              <v-text-field
                label="Nom de Version"
                outlined
                dense
                v-model="mobile.version_name"
                prepend-inner-icon="mdi-tag"
                placeholder="ex: 1.0.0"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6">
              <v-text-field
                label="Numéro de Version"
                outlined
                dense
                v-model="mobile.version_code"
                prepend-inner-icon="mdi-numeric"
                placeholder="ex: 1"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions class="dialog-actions">
          <v-spacer></v-spacer>
          <v-btn text @click="close" class="cancel-btn">Annuler</v-btn>
          <v-btn color="secondary" @click="save" :loading="loading" :disabled="loading" class="save-btn">
            <v-icon left small>mdi-upload</v-icon>
            Téléverser
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Internal APK Dialog -->
    <v-dialog v-model="internalDialog" max-width="650px">
      <v-card class="modern-card">
        <v-card-title class="dialog-title">
          <v-icon left color="primary">mdi-flask</v-icon>
          Nouvelle APK Interne
        </v-card-title>
        <v-card-text class="dialog-content">
          <v-row>
            <v-col cols="12">
              <v-file-input
                outlined
                dense
                v-model="internalMobile.file"
                label="Fichier APK interne"
                prepend-inner-icon="mdi-file-document"
                prepend-icon=""
                accept=".apk"
              ></v-file-input>
            </v-col>
            <v-col cols="12" sm="6">
              <v-text-field
                label="Nom de Version"
                outlined
                dense
                v-model="internalMobile.version_name"
                prepend-inner-icon="mdi-tag"
                placeholder="ex: Internal QA Build"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6">
              <v-text-field
                label="Numéro de Version"
                outlined
                dense
                v-model="internalMobile.version_code"
                prepend-inner-icon="mdi-numeric"
                placeholder="ex: 1.0.8"
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-textarea
                outlined
                dense
                rows="4"
                label="Notes initiales (1 note par ligne)"
                prepend-inner-icon="mdi-note-text"
                v-model="internalMobile.notes_text"
                placeholder="Fix login timeout&#10;Improve sync speed"
              ></v-textarea>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions class="dialog-actions">
          <v-spacer></v-spacer>
          <v-btn text @click="closeInternal" class="cancel-btn">Annuler</v-btn>
          <v-btn color="secondary" @click="saveInternal" :loading="internalLoading" :disabled="internalLoading" class="save-btn">
            <v-icon left small>mdi-upload</v-icon>
            Téléverser interne
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Preloader -->
    <PreloaderComponent :enable="enable"></PreloaderComponent>

    <!-- Content -->
    <div class="content-container" v-if="enable">
      <v-card class="data-card">
        <v-card-title class="card-header">
          <v-icon left color="primary">mdi-android</v-icon>
          Version actuelle
        </v-card-title>
        
        <v-card-text class="apk-content">
          <v-row align="center">
            <v-col cols="12" md="4">
              <div class="apk-info">
                <div class="info-label">Nom de Version</div>
                <div class="info-value">{{ rows.version_name }}</div>
              </div>
            </v-col>
            <v-col cols="12" md="4">
              <div class="apk-info">
                <div class="info-label">Numéro de Version</div>
                <div class="info-value">{{ rows.version_code }}</div>
              </div>
            </v-col>
            <v-col cols="12" md="4" class="text-right">
              <v-btn
                color="success"
                :href="getDownloadUrl(rows.url)"
                target="_blank"
                download
                class="download-btn"
              >
                <v-icon left>mdi-download</v-icon>
                Télécharger APK
              </v-btn>
            </v-col>
          </v-row>
          <v-row v-if="rows.created_at" class="apk-date-row" align="center">
            <v-col cols="12">
              <div class="apk-info">
                <div class="info-label">Date de mise à jour</div>
                <div class="info-value info-value--date">{{ formattedCreatedAt }}</div>
              </div>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>

      <v-card class="data-card internal-card">
        <v-card-title class="card-header">
          <v-icon left color="primary">mdi-flask</v-icon>
          Version interne (test)
          <v-spacer></v-spacer>
          <v-btn
            v-if="isAdmin"
            small
            color="secondary"
            class="upload-internal-btn"
            @click="internalDialog = true"
          >
            <v-icon left small>mdi-upload</v-icon>
            Uploader interne
          </v-btn>
        </v-card-title>

        <v-card-text class="apk-content" v-if="internalRows">
          <v-row align="center">
            <v-col cols="12" md="4">
              <div class="apk-info">
                <div class="info-label">Nom de Version</div>
                <div class="info-value">{{ internalRows.version_name }}</div>
              </div>
            </v-col>
            <v-col cols="12" md="4">
              <div class="apk-info">
                <div class="info-label">Numéro de Version</div>
                <div class="info-value">{{ internalRows.version_code }}</div>
              </div>
            </v-col>
            <v-col cols="12" md="4" class="text-right">
              <div class="internal-download-actions">
                <v-btn
                  color="success"
                  :href="getDownloadUrl(internalRows.url)"
                  target="_blank"
                  download
                  class="download-btn"
                >
                  <v-icon left>mdi-download</v-icon>
                  Télécharger APK interne
                </v-btn>
                <v-btn
                  outlined
                  color="secondary"
                  :href="getInternalDirectDownloadUrl()"
                  target="_blank"
                  class="download-btn direct-download-btn"
                >
                  <v-icon left>mdi-link-variant</v-icon>
                  Lien direct latest
                </v-btn>
              </div>
            </v-col>
          </v-row>

          <v-row v-if="internalRows.created_at || internalRows.updated_at" class="apk-date-row" align="center">
            <v-col cols="12" md="6" v-if="internalRows.created_at">
              <div class="apk-info">
                <div class="info-label">Date de création interne</div>
                <div class="info-value info-value--date">{{ formattedInternalCreatedAt }}</div>
              </div>
            </v-col>
            <v-col cols="12" md="6" v-if="internalRows.updated_at">
              <div class="apk-info">
                <div class="info-label">Dernière mise à jour interne</div>
                <div class="info-value info-value--date">{{ formattedInternalUpdatedAt }}</div>
              </div>
            </v-col>
          </v-row>

          <v-divider class="my-4"></v-divider>

          <div class="info-label">Notes de version</div>
          <v-list dense class="notes-list" v-if="formattedNotes.length">
            <v-list-item v-for="(note, idx) in formattedNotes" :key="idx">
              <v-list-item-content>
                <v-list-item-title>{{ note.message }}</v-list-item-title>
                <v-list-item-subtitle>{{ note.timestamp }}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-list>
          <div v-else class="empty-notes">Aucune note pour cette version interne.</div>

          <v-row v-if="isAdmin" class="mt-2">
            <v-col cols="12" md="9">
              <v-text-field
                outlined
                dense
                hide-details="auto"
                label="Ajouter une remarque"
                v-model="newInternalNote"
                prepend-inner-icon="mdi-note-plus"
                @keyup.enter="appendInternalNote"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="3" class="text-right">
              <v-btn
                color="secondary"
                class="save-note-btn"
                :loading="internalNoteLoading"
                :disabled="internalNoteLoading || !newInternalNote.trim()"
                @click="appendInternalNote"
              >
                <v-icon left small>mdi-content-save</v-icon>
                Sauvegarder
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>

        <v-card-text v-else class="apk-content">
          <div class="empty-notes">Aucune version interne disponible.</div>
        </v-card-text>
      </v-card>
    </div>
  </div>
</template>

<script>
import PreloaderComponent from '../components/PreloaderComponent.vue'

export default {
  name: 'APKView',
  methods: {
    load: function(){
      var self = this;
      this.$axios.get('/mobile')
        .then(function (response) {
          Object.assign(self.rows, response.data.result)
          self.loadInternalLatest()
        }).catch(function(error){
          console.log(error)
          self.loadInternalLatest()
        })
    },
    loadInternalLatest: function () {
      var self = this
      this.$axios.get('/internal-apk/latest')
        .then(function (response) {
          if (response.data && response.data.success && response.data.result) {
            self.internalRows = response.data.result
          } else {
            self.internalRows = null
          }
          self.enable = true
        }).catch(function (error) {
          console.log(error)
          self.internalRows = null
          self.enable = true
        })
    },
      save: function(){
        var self = this
        this.loading = true
        var formdata = new FormData();
        formdata.append('file', this.mobile.file);
        formdata.append('version_name', this.mobile.version_name);
        formdata.append('version_code', this.mobile.version_code);
        this.$axios.post('/mobile', formdata, {
          headers: { 'Content-Type': 'multipart/form-data' }
        })
          .then(response => {
            Object.assign(self.rows, response.data.result)
            self.dialog = false
            self.loading = false
            self.reset()
        }).catch(function(error){
          console.log(error)
          self.loading = false
        })
      },
      saveInternal: function () {
        var self = this
        this.internalLoading = true
        var formdata = new FormData()
        formdata.append('file', this.internalMobile.file)
        formdata.append('version_name', this.internalMobile.version_name)
        formdata.append('version_code', this.internalMobile.version_code)
        var parsedNotes = this.parseNotesFromText(this.internalMobile.notes_text)
        parsedNotes.forEach(function (note, index) {
          formdata.append('notes[' + index + '][message]', note.message)
        })
        this.$axios.post('/internal-apk/upload', formdata, {
          headers: { 'Content-Type': 'multipart/form-data' }
        }).then(function (response) {
          if (response.data && response.data.result) {
            self.internalRows = response.data.result
          }
          self.internalDialog = false
          self.internalLoading = false
          self.resetInternal()
          self.enable = true
        }).catch(function (error) {
          console.log(error)
          self.internalLoading = false
        })
      },
      appendInternalNote: function () {
        var self = this
        if (!this.internalRows || !this.internalRows.id || !this.newInternalNote.trim()) {
          return
        }
        this.internalNoteLoading = true
        this.$axios.patch('/internal-apk/' + this.internalRows.id + '/notes', {
          note: this.newInternalNote.trim()
        }).then(function (response) {
          if (response.data && response.data.result) {
            self.internalRows = response.data.result
          }
          self.newInternalNote = ''
          self.internalNoteLoading = false
        }).catch(function (error) {
          console.log(error)
          self.internalNoteLoading = false
        })
      },
      parseNotesFromText: function (text) {
        if (!text || !text.trim()) {
          return []
        }
        return text
          .split('\n')
          .map(note => note.trim())
          .filter(Boolean)
          .map(note => ({ message: note }))
      },
      formatTimestamp: function (timestamp) {
        if (!timestamp) {
          return ''
        }
        var parsed = new Date(timestamp)
        if (Number.isNaN(parsed.getTime())) {
          return timestamp
        }
        return parsed.toLocaleString('fr-FR')
      },
      getDownloadUrl: function (url) {
        if (!url) {
          return '#'
        }
        if (url.startsWith('http://') || url.startsWith('https://')) {
          return url
        }
        return this.current_domain + url
      },
      getInternalDirectDownloadUrl: function () {
        var base = this.$axios && this.$axios.defaults && this.$axios.defaults.baseURL
          ? this.$axios.defaults.baseURL
          : (this.current_domain + 'api/v3/')
        var normalizedBase = base.replace(/\/+$/, '')
        return normalizedBase + '/internal-apk/download/latest'
      },
      close: function(){
        this.dialog = false
        this.reset()
        this.loading = false
      },
      closeInternal: function () {
        this.internalDialog = false
        this.resetInternal()
        this.internalLoading = false
      },
      reset: function(){
        this.mobile = {
          version_name: '',
          version_code: '',
          file: [],
        }
        this.index = -1
        this.form_title = 'Nouvelle APK'
      },
      resetInternal: function () {
        this.internalMobile = {
          version_name: '',
          version_code: '',
          file: [],
          notes_text: ''
        }
      },
      closeDelete () {
        this.dialogDelete = false
        this.$nextTick(() => {
          this.reset()
        })
      },
  },
  mounted(){
    this.load()
  },
  computed: {
    isAdmin() {
      var user = this.$store.getters.StateUser
      return user && user.role_id === 1
    },
    formattedNotes() {
      if (!this.internalRows || !Array.isArray(this.internalRows.notes)) {
        return []
      }
      return this.internalRows.notes.map((note) => ({
        message: note && note.message ? note.message : '',
        timestamp: this.formatTimestamp(note && note.timestamp ? note.timestamp : '')
      }))
    },
    formattedCreatedAt() {
      var raw = this.rows.created_at
      if (!raw) return ''
      var normalized = typeof raw === 'string' ? raw.replace(' ', 'T') : raw
      var d = new Date(normalized)
      if (isNaN(d.getTime())) return ''
      var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
      var dd = String(d.getDate()).padStart(2, '0')
      var mmm = months[d.getMonth()]
      var yyyy = d.getFullYear()
      var h24 = d.getHours()
      var ampm = h24 >= 12 ? 'PM' : 'AM'
      var h12 = h24 % 12
      if (h12 === 0) h12 = 12
      var hh = String(h12).padStart(2, '0')
      var mm = String(d.getMinutes()).padStart(2, '0')
      return dd + '/' + mmm + '/' + yyyy + ' ' + hh + ':' + mm + ' ' + ampm
    },
    formattedInternalCreatedAt() {
      return this.formatTimestamp(this.internalRows && this.internalRows.created_at ? this.internalRows.created_at : '')
    },
    formattedInternalUpdatedAt() {
      return this.formatTimestamp(this.internalRows && this.internalRows.updated_at ? this.internalRows.updated_at : '')
    }
  },
  data: () => ({
      search: '',
      current_domain: 'https://api.keslakay.com/',
      index: -1,
      loading: false,
      internalLoading: false,
      internalNoteLoading: false,
      form_title: "Nouvelle APK",
      items: [
        {
          text: 'Gestion APK',
          disabled: false,
          href: '/apk',
        }
      ],
      fluid: true,
      enable: false,
      rows: {},
      internalRows: null,
      roles: [],
      dialog:'',
      internalDialog: false,
      dialogDelete: false,
      newInternalNote: '',
      mobile: {
        version_name: '',
        version_code: '',
        file: [],
      },
      internalMobile: {
        version_name: '',
        version_code: '',
        file: [],
        notes_text: ''
      }
    }),
  components: { PreloaderComponent },
}
</script>

<style lang="scss" scoped>
.apk-view {
  min-height: 100%;
}

.page-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 24px;
  
  .page-title {
    font-size: 24px;
    font-weight: 600;
    margin: 0;
  }
  
  .page-subtitle {
    font-size: 14px;
    color: rgba(0, 0, 0, 0.6);
    margin: 4px 0 0;
  }
}

.theme--dark .page-subtitle {
  color: rgba(255, 255, 255, 0.6);
}

.add-btn {
  text-transform: none !important;
  font-weight: 500 !important;
  padding: 0 24px !important;
}

.content-container {
  padding: 0 24px 24px;
}

.data-card {
  border-radius: 12px !important;
  overflow: hidden;
}

.internal-card {
  margin-top: 20px;
}

.card-header {
  padding: 20px !important;
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
  font-weight: 600;
}

.apk-content {
  padding: 32px 24px !important;
}

.apk-date-row {
  margin-top: 8px;
}

.apk-info {
  .info-label {
    font-size: 12px;
    font-weight: 500;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    color: rgba(0, 0, 0, 0.5);
    margin-bottom: 8px;
  }
  
  .info-value {
    font-size: 20px;
    font-weight: 600;
    color: #003F74;
  }

  .info-value--date {
    font-size: 16px;
    font-weight: 600;
  }
}

.theme--dark .apk-info {
  .info-label {
    color: rgba(255, 255, 255, 0.5);
  }
  
  .info-value {
    color: #4A90D9;
  }
}

.download-btn {
  text-transform: none !important;
  font-weight: 500 !important;
  padding: 0 24px !important;
}

.upload-internal-btn {
  text-transform: none !important;
}

.save-note-btn {
  text-transform: none !important;
}

.internal-download-actions {
  display: flex;
  flex-direction: column;
  gap: 8px;
  align-items: flex-end;
}

.internal-download-actions .download-btn {
  width: 240px;
}

.direct-download-btn {
  width: 240px;
}

.notes-list {
  border: 1px solid rgba(0, 0, 0, 0.08);
  border-radius: 8px;
  background: rgba(0, 0, 0, 0.01);
}

.empty-notes {
  color: rgba(0, 0, 0, 0.55);
  font-size: 14px;
}

.theme--dark .empty-notes {
  color: rgba(255, 255, 255, 0.7);
}

.dialog-title {
  font-size: 18px !important;
  font-weight: 600 !important;
  padding: 20px 24px !important;
  border-bottom: 1px solid rgba(0, 0, 0, 0.08);
}

.dialog-content {
  padding: 24px !important;
}

.dialog-actions {
  padding: 16px 24px !important;
  border-top: 1px solid rgba(0, 0, 0, 0.08);
}

.cancel-btn {
  text-transform: none !important;
}

.save-btn {
  text-transform: none !important;
  min-width: 140px !important;
}
</style>